import {
  FAQS,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
  TERMS_AND_CONDITION_OPT_OUT_RESTRICTED,
  RedeemGiftSuccessModalDesc,
  HomePageZeroStateDesc,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const LogoImage =
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/SLBees_Partial_FullColor_OnWhite_RGB.png";
const OrderSummaryBackgroundImage =
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/Salt%20Lake%20Bees%20v3%20Assets/Bees%20Background.png";

export const saltlakebees_pass: TTeamConfig = {
  TEAM_SCHEMA: "saltlakebees_pass",
  TEAM_FULL_NAME: "Salt Lake Bees",
  BROWSER_TITLE: "Salt Lake Bees Summer Pass",
  CLIENT_ID: "153bfc837d7c.seasonshare.slbees-slbees.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#000000",
    COLORS_SECONDARY: "#fcb82d",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/slbees/",
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      HIDE_PASS_DETAILS: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT_OPT_OUT_RESTRICTED: "Purchase Now",
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
    SHOW_ALL_PASSES_UNDER_BANNER: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      ATTEND_BUTTON_COLOR: "#fcb82d",
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },

    ZERO_STATE: {
      TITLE: "You don’t currently have a pass on your account.",
      DESCRIPTION: <HomePageZeroStateDesc />,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },

    SEND_GIFT_SUCCESS_MODAL: {
      SEND_NOW_TITLE: "Your gift is on its way!",
      SEND_NOW_DESCRIPTION:
        "Your purchase was successful. The recipient will receive an email shortly with your message and instructions for redeeming their pass.",

      SEND_LATER_TITLE: "Your gift has been scheduled! ",
      SEND_LATER_DESCRIPTION:
        "Your purchase was a success. The recipient will receive their gift email on the scheduled date, complete with your message and simple steps to redeem.",
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  REDEEM_GIFT_PAGE_SETTINGS: {
    REDEEM_SUCCESS_MODAL: {
      TITLE: "Congrats!",
      DESCRIPTION: <RedeemGiftSuccessModalDesc />,
    },
  },

  IMAGES: {
    LOGO_URL: LogoImage,
    ORDER_SUMMERY_BACKGROUND_URL: OrderSummaryBackgroundImage,
    GROUP_INVITE_PAGE_STATIC_BANNER_URL: OrderSummaryBackgroundImage,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PASS_PURCHASE_SUCCESS_MESSAGE,
    TERMS_AND_CONDITION_OPT_OUT_RESTRICTED,
  },
};
